// ドメイン定義
// ローカル
// export const API_BASE_URL = "http://localhost:8000"
// DEV
// export const API_BASE_URL = "https://kaxyrz1ge7.execute-api.ap-northeast-1.amazonaws.com/dev"
// STG
// export const API_BASE_URL = "https://ko39im49ik.execute-api.ap-northeast-1.amazonaws.com/api"
// PROD
export const API_BASE_URL = "https://cjgeuouxzd.execute-api.ap-northeast-1.amazonaws.com/api"

// HelpPage
//export const HELP_PAGE = "http://smart-activity-detection-help.s3-website-ap-northeast-1.amazonaws.com/"
export const HELP_PAGE = "https://help.denpademiterukun.com/"
